import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { IStructure } from '../model/structure.model';

@Injectable({
  providedIn: 'root'
})
export class StructureService {
  public readonly resourceUrl = environment.apiServerUrl + 'structures';

  constructor(protected http: HttpClient) {
  }

  find(): Observable<HttpResponse<IStructure[]>> {
    return this.http
      .get<IStructure[]>(this.resourceUrl, { observe: 'response' });
  }

  findByNumero(numero: number): Observable<HttpResponse<IStructure>> {
    return this.http
      .get<IStructure>(`${this.resourceUrl}/${numero}`, { observe: 'response' });
  }

  findStructuresTerritoireGroupe(): Observable<HttpResponse<IStructure[]>> {
    return this.http
      .get<IStructure[]>(`${this.resourceUrl}/type/territoire-groupe`, {observe: 'response'});
  }

  findUnitesByGroupe(structure: string): Observable<HttpResponse<IStructure[]>> {
    return this.http
      .get<IStructure[]>(`${this.resourceUrl}/unites/${structure}`, {observe: 'response'});
  }

  findAllStructures(): Observable<HttpResponse<IStructure[]>> {
    return this.http
      .get<IStructure[]>(`${this.resourceUrl}/all-structures`, { observe: 'response' });
  }
}
